import { Typography } from "@mui/material";
import * as _ from "lodash";
import { stringSimilarity } from "string-similarity-js";

import { FORBIDDEN_CHARS } from "@/constants/forbiddenCharacters";

export const getMappedColumns = (template) => {
  const mappedColumns = new Set();
  Object.keys(template).forEach((category) => {
    Object.values(template[category]).forEach((subcategory) => {
      subcategory.forEach((adaField) => {
        if (adaField.affiliate_columns) {
          adaField.affiliate_columns.forEach((mappedValue) => {
            if (!mappedValue?.startsWith("@:")) {
              mappedColumns.add(mappedValue);
            }
          });
        }
      });
    });
  });
  return mappedColumns;
};

const getAdaFields = (template) => {
  const adaFields = [];

  Object.keys(template).forEach((category) => {
    Object.entries(template[category]).forEach(([subcatName, subcategory]) => {
      subcategory.forEach((adaField) => {
        adaFields.push({
          ...adaField,
          subcategory: subcatName,
          category,
        });
      });
    });
  });
  return adaFields;
};

const removePriorityFields = (template) => {
  Object.keys(template).forEach((category) => {
    Object.values(template[category]).forEach((subcategory) => {
      subcategory.forEach((adaField) => {
        delete adaField.priority;
      });
    });
  });
  return template;
};

export const templateHasChanged = (storeTemplate, updatedTemplate) => {
  storeTemplate = removePriorityFields(JSON.parse(storeTemplate));
  updatedTemplate = removePriorityFields(updatedTemplate);
  return !_.isEqual(storeTemplate, updatedTemplate);
};

export const hasForbiddenChar = (s) => {
  const forbidden = new Set(FORBIDDEN_CHARS);
  return s.split("").some((char) => forbidden.has(char));
};

// TEMPLATE ERROR MESSAGING
export const getInvalidColumnData = (template, availableColumns) => {
  const badColumnData = [];
  const adaFields = getAdaFields(template);
  let closeMatches;

  adaFields.forEach((adaField) => {
    let unavailableColumn;
    adaField.affiliate_columns?.forEach((value) => {
      if (
        // value exists
        value &&
        // not a string literal
        !value.startsWith("@:") &&
        // not in the list of uploaded affiliate column names
        !availableColumns.includes(value)
      ) {
        unavailableColumn = value;
        closeMatches = similarStrings(value, availableColumns, 0.45);
      }
    });
    if (unavailableColumn) {
      const fullName = `${adaField.category}.${adaField.subcategory}.${adaField.name}`;
      const badColumn = {
        unavailable: unavailableColumn,
        fullname: fullName,
        closeMatch: closeMatches,
      };
      badColumnData.push(badColumn);
    }
  });
  return badColumnData;
};

// format array of message strings into paragraphs for notification display
export const formatErrorNotification = (errors, message = null) => {
  if (errors && Array.isArray(errors)) {
    return (
      <div>
        {message && <div>{message}</div>}
        <br></br>
        {errors.map((error, index) => (
          <>
            <p key={index}>{error}</p>
          </>
        ))}
      </div>
    );
  }
  return <Typography variant="body1">An unexpected error occurred.</Typography>;
};

const similarStrings = (needle, haystack, threshold = 0.75) => {
  const matches = [];
  haystack.forEach((str) => {
    if (stringSimilarity(needle, str) > threshold) {
      matches.push(str);
    }
  });
  return matches;
};
